export const state = {
  accessTypes: {
    READ: 1,
    WRITE: 2,
    ADMIN: 3,
  },
  authToken: null,
  evollead_server: process.env.VUE_APP_LEADS_URL,
  evollauth_server: process.env.VUE_APP_AUTH_URL,
  ebooking_server: process.env.VUE_APP_EBOOKING_URL,
  clinical_server: process.env.VUE_APP_CLINICAL_URL,
  evocall_server: process.env.VUE_APP_EVOCALL_URL,
  homelab_server: process.env.VUE_APP_HOMELAB_URL,
  auth_clinical_server: process.env.VUE_APP_AUTH_CLINICAL_URL,
  optometry_server: process.env.VUE_APP_OPTOMETRY_URL,
  reports_server: process.env.VUE_APP_REPORTS_URL,
  ranu_server: process.env.VUE_APP_RANU_URL,
  notifications_server: process.env.VUE_APP_NOTIFICATIONS_URL,
  leads_web_server: process.env.VUE_APP_LEADS_WEB_URL,
  iframe_server: process.env.VUE_APP_IFRAME_URL,
  iframe_token: process.env.VUE_APP_IFRAME_TOKEN,
  statistics2_server: process.env.VUE_APP_STATISTICS_V2_URL,
  virtual_waiting_room_server: process.env.VUE_APP_VIRTUAL_WAITING_ROOM_URL,
  onecare_server: process.env.VUE_APP_ONECARE_API_URL,
  a4a_server: process.env.VUE_APP_A4A_URL,
  wellbeing_server: process.env.VUE_APP_WELLBEING_URL,
  activities_agenda_server: process.env.VUE_APP_ACTIVITIES_AGENDA_URL,
  people_manager_server: process.env.VUE_APP_PEOPLE_MANAGER_URL,
  evohealth_server: process.env.VUE_APP_EVOHEALTH_URL,
  authEntities: [],
  clusters: [],
  businessPlans: [],
  services: [],
  hasLoaded: false,
  redirectFrom: null,
  loggedUser: null,
  successToastOptions: {
    className: 'vuestic-toast',
    icon: 'fa-check',
    position: 'top-right',
    duration: 2500,
    fullWidth: false,
  },
  errorToastOptions: {
    className: 'vuestic-toast danger',
    icon: 'fa-exclamation-triangle',
    position: 'top-right',
    duration: 2500,
    fullWidth: false,
  },
  allowedCountries: ['PT', 'EN', 'ES', 'CZ'],
  authClinicalServiceIds: [15, 16],
  evocallServiceIds: [8],
  dynamicModules: new Set(),
  icons: {
    1: 'i-menu-audiology-dark',
    2: 'i-menu-booking-dark',
    3: 'fa fa-heartbeat',
    4: 'fa fa-medkit',
    5: 'i-menu-audiology-dark',
    6: 'i-menu-config-dark',
    7: 'i-menu-reports-dark',
    8: 'i-menu-audiology-dark',
    9: 'i-menu-booking-dark',
    10: 'i-menu-reports-dark',
    11: 'fa fa-child',
    15: 'i-menu-evollu-dark',
    16: 'i-menu-acustica-dark',
    17: 'i-menu-optometry-dark',
    18: 'i-menu-audiology-dark',
    19: 'i-menu-reports-dark',
    20: 'i-menu-stats-dark',
    21: 'i-menu-acustica-dark',
    22: 'i-menu-checkup-plus-dark',
    23: 'i-menu-wellbeing',
    24: 'i-menu-booking-dark',
    25: 'fa fa-user',
    26: 'fa fa-notes-medical',
  },
  languages: [{
    'id': 0,
    'lang': 'pt',
    'emoji': '🇵🇹',
    'language_key': 'portuguese',
  },
    {
      'id': 1,
      'lang': 'en',
      'emoji': '🇬🇧',
      'language_key': 'english',
    },
    {
      'id': 2,
      'lang': 'es',
      'emoji': '🇪🇸',
      'language_key': 'spanish',
    },
    {
      'id': 3,
      'lang': 'cz',
      'emoji': '🇨🇿',
      'language_key': 'czech',
    }],
  oneCareToken: null,
  oneCareBaseUrl: null,
  shouldShowPasswordRenewalWarning: false,
};
